'use client'

import { useEffect } from 'react'
import { initializeMobileChromeSupport } from '@/utils/mobileCacheUtils'
import { useOfflineSync } from '@/hooks/useOfflineSync'

export default function MobileCacheProvider() {
  useOfflineSync()

  useEffect(() => {
    // Initialize mobile Chrome cache management
    initializeMobileChromeSupport()
  }, [])

  return null // This component doesn't render anything
}
